var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-banner"},[_c('div',{staticClass:"slogan"},[_c('h1',[_vm._v("让您的资产更具生命力")]),_c('h3',[_vm._v("庆源绿色金融，您的资产管家")])])])}]

export { render, staticRenderFns }